<div class="card" style="position: relative">
    <span class="page-title"
        ><i class="bi bi-whatsapp page-title-icon"></i>Whatsapp Templates</span
    >
    <p-toast></p-toast>
    <div
        class="search-customers-header flex flex-column align-items-start justify-content-start"
    >
        <div class="flex flex-column" [formGroup]="createTemplateForm">
            <p class="mb-0">
                <i class="pi pi-plus" style="color: green"></i>
                <span class="ml-2 font-semibold"
                    >Create a new Whatsapp template</span
                >
            </p>
            <input
                class="w-25rem my-3"
                pInputText
                formControlName="name"
                placeholder="*Enter template name"
            />
            <p-button
                label="Create Template"
                class="mt-2"
                (onClick)="createTemplate()"
                [disabled]="!createTemplateForm.valid"
                iconPos="right"
                severity="success"
                ><i class="pi pi-save add-customer-icon"></i
            ></p-button>
        </div>
        <div class="flex w-25rem align-items-center gap-2 my-4">
            <hr class="w-25rem" />
            <h2>OR</h2>
            <hr class="w-25rem" />
        </div>
        <div class="w-25rem flex flex-column gap-2" [formGroup]="templatesForm">
            <p class="mb-0 mt-2">
                <i class="pi pi-send" style="color: rgb(55, 135, 255)"></i>
                <span class="ml-2 font-semibold">Send a broadcast message</span>
            </p>
            <span class="w-25rem mt-3">
                <p-dropdown
                    [options]="templates"
                    formControlName="template"
                    placeholder="*Select Template"
                    optionLabel="label"
                    optionValue="value"
                    (onChange)="onTemplateChange($event)"
                    [showClear]="true"
                    [filter]="true"
                    filterBy="label"
                    [style]="{ width: '100%' }"
                ></p-dropdown>
            </span>
            <div *ngIf="templateMessage" class="mt-4">
                <p class="mb-0 template-message-title">Template Message</p>
                <p class="template-message-content">
                    {{ templateMessage.name }}
                </p>
            </div>
            <div class="actions mt-3">
                <p-button
                    label="Send Message"
                    [disabled]="!templatesForm.valid"
                    iconPos="right"
                    (click)="submitBroadcastMessages()"
                    severity="success"
                    ><i class="pi pi-arrow-right add-customer-icon"></i
                ></p-button>
            </div>
        </div>
    </div>
    <p-dialog
        [(visible)]="visible"
        [modal]="true"
        [closable]="false"
        [style]="{ width: screenWidth < 900 ? '65vw' : '35vw' }"
    >
        <app-loading [message]="loadingMessage"></app-loading>
    </p-dialog>
</div>
